module.exports = __webpack_public_path__ + "static/media/14.398d1ab0.svg";